"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openConversation = exports.closeConversations = exports.showAddConversationButton = exports.hideAddConversationButton = exports.deleteConversationFromUpdate = exports.addConversationFromUpdate = exports.deleteConversationDone = exports.deleteConversation = exports.selectConversationBlock = exports.createDummyConversation = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _constants = require("composer-lib/lib/constants");

var _ConversationsManager = _interopRequireDefault(require("composer-lib/data/ConversationsManager"));

var _utils = require("composer-lib/lib/utils");

var conversationsManager = new _ConversationsManager.default();

var createDummyConversation = function createDummyConversation(index, conversationData) {
  return function (dispatch) {
    var payload = Object.assign({}, conversationData, {
      correlationId: index
    });
    dispatch((0, _utils.createAction)(_ActionTypes.default.CREATE_DUMMY_CONVERSATION)(payload, (0, _defineProperty2.default)({}, _constants.TRACK_EVENT_META_KEY, {
      action: 'conversation-created',
      name: _constants.AmplitudeEvents.COMPOSITION_COLLABORATION
    })));
  };
};

exports.createDummyConversation = createDummyConversation;

var selectConversationBlock = function selectConversationBlock(index) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SELECT_CONVERSATION_BLOCK)(index));
  };
};

exports.selectConversationBlock = selectConversationBlock;
var deleteConversationPending = (0, _utils.createAction)(_ActionTypes.default.DELETE_CONVERSATION_PENDING);
var deleteConversationSucceeded = (0, _utils.createAction)(_ActionTypes.default.DELETE_CONVERSATION_SUCCEEDED);
var deleteConversationFailed = (0, _utils.createAction)(_ActionTypes.default.DELETE_CONVERSATION_FAILED);
var deleteEmptyConversation = (0, _utils.createAction)(_ActionTypes.default.DELETE_EMPTY_CONVERSATION);

var deleteConversation = function deleteConversation(_ref) {
  var idToDelete = _ref.idToDelete,
      idInState = _ref.idInState,
      correlationId = _ref.correlationId,
      isDummy = _ref.isDummy,
      isEmptyConversation = _ref.isEmptyConversation;
  return function (dispatch) {
    if (idToDelete !== null) {
      if (isEmptyConversation) {
        // In this case, we want to instantly remove it from the UI w/o messaging
        // or waiting for response, and just fire delete request for it in the background.
        // This uses a safe delete that will only delete if there are truly no comments
        // associated with the conversation, but we will optimistically remove it from UI either way.
        // (if this session thought it had 0 comments, then the state is out of sync anyways)
        dispatch(deleteEmptyConversation({
          correlationId: correlationId,
          idInState: idInState
        }));

        if (!isDummy) {
          conversationsManager.safelyDeleteEmptyConversation(idToDelete);
        }
      } else {
        dispatch(deleteConversationPending(idInState));
        conversationsManager.deleteConversation(idToDelete).then(function () {
          return dispatch(deleteConversationSucceeded());
        }, function () {
          return dispatch(deleteConversationFailed());
        });
      }
    } else {
      dispatch(deleteEmptyConversation({
        correlationId: correlationId,
        idInState: idInState
      }));
    }
  };
};

exports.deleteConversation = deleteConversation;

var deleteConversationDone = function deleteConversationDone(conversation) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.DELETE_CONVERSATION_DONE)(conversation));
  };
};

exports.deleteConversationDone = deleteConversationDone;

var addConversationFromUpdate = function addConversationFromUpdate(conversationData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_ADD_CONVERSATION)(conversationData));
  };
};

exports.addConversationFromUpdate = addConversationFromUpdate;

var deleteConversationFromUpdate = function deleteConversationFromUpdate(conversationData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_DELETE_CONVERSATION)(conversationData));
  };
};

exports.deleteConversationFromUpdate = deleteConversationFromUpdate;

var hideAddConversationButton = function hideAddConversationButton() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.HIDE_ADD_CONVERSATION_BUTTON)());
  };
};

exports.hideAddConversationButton = hideAddConversationButton;

var showAddConversationButton = function showAddConversationButton(blockKey) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SHOW_ADD_CONVERSATION_BUTTON)(blockKey));
  };
};

exports.showAddConversationButton = showAddConversationButton;

var closeConversations = function closeConversations(conversationIds) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.CLOSE_CONVERSATIONS)(conversationIds));
  };
};

exports.closeConversations = closeConversations;

var openConversation = function openConversation(conversationId) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.OPEN_CONVERSATION)(conversationId));
  };
};

exports.openConversation = openConversation;